import { Injectable } from '@angular/core';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { ToweInDealerRequestModel,ToweInUsageRequestModel } from '../business-entities/towed-in-report-model';
@Injectable({
  providedIn: 'root'
})
export class ToweInUserDataService {
  constructor(private dataService: DataService) { }

  async getToweInUsageList(requestModel: ToweInUsageRequestModel): Promise<GenericResponse<any>> {
    return this.dataService.Post<GenericResponse<any>>(Urls.GetToweInUsageList, requestModel).toPromise();
  }

  async getToweInUsageDealerWiseList(requestModel: ToweInDealerRequestModel): Promise<GenericResponse<any>> {
    return this.dataService.Post<GenericResponse<any>>(Urls.GetToweInUsageDealerWiseList, requestModel).toPromise();
  }
}